<template>
  <div class="buildings-content">
    <div v-if="$route.path.includes('edit') || $route.path.includes('create')" class="sub-header">
      <b-container fluid>
        <appCatalogsNav
          v-if="$route.path.includes('asl/create')"
          :title="titleCreateAsl"
          :breadcrumb-last="breadcrumbLastCreate"
          :breadcrumb-route-text="breadcrumbRouteText"
          :breadcrumb-route-name="breadcrumbRouteName"
        />
        <appCatalogsNav
          v-else-if="$route.path.includes('asl/edit')"
          :title="titleEdit"
          :breadcrumb-last="breadcrumbLastEdit"
          :breadcrumb-route-text="breadcrumbRouteText"
          :breadcrumb-route-name="breadcrumbRouteName"
        />
        <appCatalogsNav
          v-else-if="$route.path.includes('create')"
          :title="titleCreate"
          :breadcrumb-last="breadcrumbLastCreate"
          :breadcrumb-route-text="breadcrumbRouteText"
          :breadcrumb-route-name="breadcrumbRouteName"
        />
        <appCatalogsNav
          v-else-if="$route.path.includes('edit')"
          :title="titleEdit"
          :breadcrumb-last="breadcrumbLastEdit"
          :breadcrumb-route-text="breadcrumbRouteText"
          :breadcrumb-route-name="breadcrumbRouteName"
        />
      </b-container>
    </div>

    <b-container fluid>
      <div v-if="!$route.path.includes('edit') && !$route.path.includes('create')">
        <b-container>
          <b-button class="button btn-blue my-4 fw-600" :to="{ name: 'create-building' }">
            <font-awesome-icon class="agv-button-icon" icon="plus" />
            <span>{{ $t("catalogs.buildings_create") }}</span>
          </b-button>
          <b-button class="button btn-blue my-4 fw-600 ml-3" :to="{ name: 'create-building-asl' }">
            <font-awesome-icon class="agv-button-icon" icon="plus" />
            <span>{{ $t("catalogs.buildings_asl_create") }}</span>
          </b-button>
        </b-container>

        <b-container>
          <appBuildingsTable></appBuildingsTable>
        </b-container>
      </div>

      <router-view />
    </b-container>
  </div>
</template>

<script>
import appCatalogsNav from "@/components/snippets/CatalogsNav";

import BuildingMW from "@/middlewares/Building";
import BuildingORM from "@/store/orm-axios/models/Building";

import mercureMixin from "@/mixins/mercure-live-changes/buildings";

export default {
  components: {
    appCatalogsNav,
    appBuildingsTable: () => import("@/components/catalogs/buildings/BuildingsTable"),
  },
  mixins: [mercureMixin],
  data() {
    return {
      titleCreate: this.$t("catalogs.buildings_create"),
      titleCreateAsl: this.$t("catalogs.buildings_asl_create"),
      breadcrumbLastCreate: this.$t("general.create"),
      titleEdit: this.$t("catalogs.buildings_edit"),
      titleEditAsl: this.$t("catalogs.buildings_asl_edit"),
      breadcrumbLastEdit: this.$t("general.edit"),
      breadcrumbRouteText: this.$t("catalogs.buildings"),
      breadcrumbRouteName: "buildings",
      BuildingMW: BuildingMW,
      BuildingORM: BuildingORM,
    };
  },
};
</script>
